import { Providers } from '../Providers';
import { ScProvidersWrapper } from './styled';

export const RegModalProviders = () => (
  <ScProvidersWrapper>
    <Providers />
  </ScProvidersWrapper>
);
